var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mfe-base',{attrs:{"error":_vm.error}},[_c('div',{ref:"mounter",staticClass:"micro-front-end-container",attrs:{"data-sb-automation":"merchant-app-inventory-status-mounter"}},[_c('Splash',{attrs:{"id":"loader-splash","message":"Loading..."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }